import { appAlignLeft01Icon } from './align-left-01';
import { appAlignRight01Icon } from './align-right-01';
import { appDividerIcon } from './divider';
import { appGrid01Icon } from './grid-01';
import { appGrid02Icon } from './grid-02';
import { appLayoutGrid02Icon } from './layout-grid-02';
import { appListIcon } from './list';
import { appTableIcon } from './table';
export const layoutIcons = [appAlignLeft01Icon, appAlignRight01Icon, appDividerIcon, appGrid01Icon, appGrid02Icon, appLayoutGrid02Icon, appListIcon, appTableIcon];
